import { lazy } from 'react';

const BookTruck = lazy(() => import('components/BookTruck/BookTruck'));
const Login = lazy(() => import('components/Login/Login'));
const OpDetailsPage = lazy(() => import('components/Operations/DetailPage/detailsWrapper'));
const OldPortalRedirect = lazy(() => import('components/OldPortalRedirect/OldPortalRedirect'));
const Consigner = lazy(() => import('components/Consigner/Consigner'));
const Operations = lazy(() => import('components/Operations/Operations'));
const Placement = lazy(() => import('pages/Placement/Placement'));
const ThirdParty = lazy(() => import('components/ThirdParty/thirdParty'));
const LaneRateDashboard = lazy(() => import('components/LaneRateDashboard/laneRateDashboard'));
const CreateDemand = lazy(() => import('components/CreateDemand/createDemand'));
const CreateDemandPTL = lazy(() => import('components/CreateDemandPTL/createDemand'));
const PTLFreightUpload = lazy(() => import('components/PTLFreightUpload/ptlFreightUpload'));
const PTLTaskDashBoard = lazy(() => import('components/PTLTaskDashBoard/ptlTaskDashBoard'));
const Operator = lazy(() => import('components/Operator/Operator'));
const WebViews = lazy(() => import('components/WebViews/WebViews'));
const PlacementDetailPage = lazy(() => import('pages/Placement/Detail/DetailWrapper'));
const LMS = lazy(() => import('pages/lms'));
const Transactions = lazy(() => import('pages/transactions'));
const IssueCreation = lazy(() => import('pages/IssueCreation'));
const OperatorRateInfo = lazy(() => import('pages/OperatorRateInfo'));
const ManualPlacement = lazy(() => import('pages/ManualPlacement'));
/**Mobile Imports */
const PlacementMob = lazy(() => import('pages/mobile/placement'));
const PlacementDetailPageMob = lazy(() => import('pages/mobile/placement/details'));

const Ticketing = lazy(() => import('pages/ticketing/ticketing'));
const TicketingDetailsPage = lazy(() => import('pages/ticketing/Details/detailPage'));

const CMS = lazy(() => import('pages/cms'));
const CmsEditor = lazy(() => import('pages/cms/CmsEditorPage'));
const CmsGuide = lazy(() => import('pages/cms/CmsGuidePage'));
const Permission = lazy(() => import('pages/permissions'));

const PTLBulkMIS = lazy(() => import('components/PTLBulkMIS/ptlBulkMIS'));
const PTLOnboarding = lazy(() => import('components/PTLOnboarding/PTLOnboarding'));
const PricingConfig = lazy(() => import('pages/pricing-config'));
const SegmentConfig = lazy(() => import('pages/segment-config'));
const TicketAssignment = lazy(() => import('pages/TicketAssignment/TicketAssignment'));
const BulkUpload = lazy(() => import('pages/bulkUpload'));
const CreativeUpload = lazy(() => import('pages/CreativeUpload'));
const Crm = lazy(() => import('pages/crm'));
const FulfilledPlacement = lazy(() => import('pages/FulfilledPlacement'));

const routes = [
  {
    path: '/portal/login',
    isPrivate: false,
    exact: true,
    component: Login,
    mobileComponent: null,
  },
  {
    path: '/portal/placement',
    isPrivate: true,
    exact: true,
    component: Placement,
    mobileComponent: PlacementMob,
  },
  {
    path: '/portal/operator-rate-info',
    isPrivate: true,
    exact: true,
    component: OperatorRateInfo,
    mobileComponent: null,
  },
  {
    path: '/portal/manual-placement',
    isPrivate: true,
    exact: true,
    component: ManualPlacement,
    mobileComponent: null,
  },
  {
    path: '/portal/fulfilled-placement',
    isPrivate: true,
    exact: true,
    component: FulfilledPlacement,
    mobileComponent: null,
  },
  {
    path: '/portal/ticketing',
    isPrivate: true,
    exact: true,
    component: Ticketing,
    mobileComponent: null,
  },
  {
    path: '/portal/ptl-ticketing',
    isPrivate: true,
    exact: true,
    component: Ticketing,
    mobileComponent: null,
  },
  {
    path: '/portal/ticketing/details',
    isPrivate: true,
    exact: true,
    component: TicketingDetailsPage,
    mobileComponent: null,
  },
  {
    path: '/portal/lane-rate-dashboard',
    isPrivate: true,
    exact: true,
    component: LaneRateDashboard,
    mobileComponent: null,
  },
  {
    path: '/portal/lms',
    isPrivate: true,
    exact: true,
    component: LMS,
    mobileComponent: null,
  },
  {
    path: '/portal/transactions',
    isPrivate: true,
    exact: true,
    component: Transactions,
    mobileComponent: null,
  },
  {
    path: '/portal/placement/details',
    isPrivate: true,
    exact: true,
    component: PlacementDetailPage,
    mobileComponent: PlacementDetailPageMob,
  },

  {
    path: '/portal/consigner',
    isPrivate: true,
    exact: true,
    component: Consigner,
    mobileComponent: null,
  },
  {
    path: '/portal/operator',
    isPrivate: true,
    exact: true,
    component: Operator,
    mobileComponent: null,
  },
  {
    path: '/portal/operations',
    isPrivate: true,
    exact: true,
    component: Operations,
    mobileComponent: null,
  },
  {
    path: '/portal/operations/details',
    isPrivate: true,
    exact: true,
    component: OpDetailsPage,
    mobileComponent: null,
  },

  {
    path: '/portal/create-demand',
    isPrivate: true,
    exact: true,
    component: CreateDemand,
    mobileComponent: null,
  },
  {
    path: '/portal/create-demand-ptl',
    isPrivate: true,
    exact: true,
    component: CreateDemandPTL,
    mobileComponent: null,
  },
  {
    path: '/portal/ptl-bulk-mis',
    isPrivate: true,
    exact: true,
    component: PTLBulkMIS,
    mobileComponent: null,
  },
  {
    path: '/portal/ptl-onboarding',
    isPrivate: true,
    exact: true,
    component: PTLOnboarding,
    mobileComponent: null,
  },
  {
    path: '/portal/pricing-config',
    isPrivate: true,
    exact: true,
    component: PricingConfig,
    mobileComponent: null,
  },
  {
    path: '/portal/segment-config',
    isPrivate: true,
    exact: true,
    component: SegmentConfig,
    mobileComponent: null,
  },
  {
    path: '/portal/ptl-freight-upload',
    isPrivate: true,
    exact: true,
    component: PTLFreightUpload,
    mobileComponent: null,
  },
  {
    path: '/portal/ptl-tasks',
    isPrivate: true,
    exact: true,
    component: PTLTaskDashBoard,
    mobileComponent: null,
  },
  {
    path: '/portal/book-truck',
    isPrivate: false,
    exact: true,
    component: BookTruck,
    mobileComponent: null,
  },
  {
    path: '/portal/wv',
    isPrivate: false,
    exact: true,
    component: WebViews,
    mobileComponent: null,
  },
  {
    path: '/portal/oldportal/:id',
    isPrivate: false,
    exact: true,
    component: OldPortalRedirect,
    mobileComponent: null,
  },
  {
    path: '/portal/third-party',
    isPrivate: true,
    exact: true,
    component: ThirdParty,
    mobileComponent: null,
  },
  {
    path: '/portal/cms',
    isPrivate: true,
    exact: true,
    component: CMS,
    mobileComponent: null,
  },
  {
    path: '/portal/cms/guide',
    isPrivate: true,
    exact: true,
    component: CmsGuide,
    mobileComponent: null,
  },
  {
    path: '/portal/cms/:pageId',
    isPrivate: true,
    exact: true,
    component: CmsEditor,
    mobileComponent: null,
  },
  {
    path: '/portal/permissions',
    isPrivate: true,
    exact: true,
    component: Permission,
    mobileComponent: null,
  },
  {
    path: '/portal/issue-creation',
    isPrivate: true,
    exact: true,
    component: IssueCreation,
    mobileComponent: null,
  },
  {
    path: '/portal/ticket-assignment',
    isPrivate: true,
    exact: true,
    component: TicketAssignment,
    mobileComponent: null,
  },
  {
    path: '/portal/bulk-upload',
    isPrivate: true,
    exact: true,
    component: BulkUpload,
    mobileComponent: null,
  },
  {
    path: '/portal/creative-upload',
    isPrivate: true,
    exact: true,
    component: CreativeUpload,
    mobileComponent: null,
  },
  {
    path: '/portal/crm',
    isPrivate: true,
    exact: true,
    component: Crm,
    mobileComponent: null,
  },
];

export { routes };
